import { render, staticRenderFns } from "./EinstellungenVeranstaltungen.vue?vue&type=template&id=78f452aa"
import script from "./EinstellungenVeranstaltungen.vue?vue&type=script&lang=js"
export * from "./EinstellungenVeranstaltungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports